import { theme as elementTheme } from "../../core/elements/index.js";
import { widget } from "@foretagsplatsen/widgetjs";
import jQuery from "jquery";
import PerfectScrollbar from "perfect-scrollbar";
import theme from "../../core/theme.js";

/**
 *
 * `actionsWidget` is the widget used as the right-hand side menu.
 * Depending on the current document, the menu can exist or not.
 *
 * An event is triggered when the menu is expanded or collapsed
 * (via `onVisibilityChange`).
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*}
 */

/**
 * Todo: Add JSDoc comment
 */
function actionsWidget(spec, my) {
	spec ||= {};
	my ||= {};

	my.showWkHeader = spec.showWkHeader;

	const that = widget(spec, my);

	that.onVisibilityChange = my.events.createEvent();

	let document;
	let open = true;

	that.setDocument = function (newDocument, hasMarketingLayer = false) {
		my.hasMarketingLayer = hasMarketingLayer;

		document = newDocument;
		document.onUpdateActions.register(my.updateActions);
		document.onShowActions.register(that.show);
		document.onHideActions.register(that.hide);
		that.update();
	};

	that.isOpen = function () {
		return open;
	};

	that.canBeDisplayed = function () {
		return (
			open &&
			document &&
			document.hasActionsMenu() &&
			!document.isActionsMenuMobileOnly()
		);
	};

	that.toggleVisibility = function () {
		if (open) {
			that.hide();
		} else {
			that.show();
		}
	};

	that.show = function () {
		open = true;
		jQuery("#rightmenu-container").show();
		that.onVisibilityChange.trigger(true);
	};

	that.hide = function () {
		open = false;
		jQuery("#rightmenu-container").hide();
		that.onVisibilityChange.trigger(false);
	};

	that.isMobileOnly = function () {
		return document && document.isActionsMenuMobileOnly();
	};

	that.renderContentOn = function (html) {
		if (my.hasMarketingLayer) {
			return;
		}

		html.div(
			{
				id: "rightmenu-container",
				klass: my.getCssClass(),
				style: that.canBeDisplayed()
					? "display: block"
					: "display: none",
			},
			elementTheme(
				{ name: "dark-select", renderOn: html },
				html
					.div({
						id: "right-menu",
						klass: { "mobile-only": that.isMobileOnly() },
					})
					.render((html) => {
						if (!document) {
							return;
						}

						html.div({
							klass: "right-menu-section mobile-only",
						}).render(
							document.renderMobileOnlyActionsOn.bind(document),
						);

						document.renderActionsOn(html);
						if (theme.showSignOff) {
							my.renderFTGPLinkOn(html);
						}
					}),
			),
		);
	};

	my.getCssClass = function () {
		return { wide: my.isWide(), "wk-header": my.showWkHeader };
	};

	my.didAttach = function () {
		const container = jQuery("#rightmenu-container");

		if (container.length === 1) {
			// eslint-disable-next-line sonarjs/constructor-for-side-effects -- don't want to change that now
			new PerfectScrollbar(container.get(0));
		}
	};

	my.updateActions = function () {
		that.update();
	};

	my.renderEmptyOn = function () {};

	my.renderFTGPLinkOn = function (html) {
		html.div(
			{ klass: "right-menu-section ftgp-link" },
			html.a(
				{ href: "https://finsit.se" },
				html.img({
					src: "/Client/img/finsit-logo-transparent.png",
				}),
			),
		);
	};

	my.isWide = function () {
		return document && document.hasWideActionsMenu();
	};

	return that;
}

export default actionsWidget;
